

export function setActiveMenuItem(url, isDropdown) {

    let menuNames = ['om_oss', 'prosess', 'team', 'kontakt_oss'];

    for(let i = 0; i < menuNames.length; i++) {
        if(menuNames[i] === url) {
            isDropdown ? document.getElementById(menuNames[i] + '-span').classList.add('navbar-dropdown-slider-static')
                       : document.getElementById(menuNames[i] + '-span').classList.add('navbar-slider-static');
        } else {
            isDropdown ? document.getElementById(menuNames[i] + '-span').classList.remove('navbar-dropdown-slider-static')
                       : document.getElementById(menuNames[i] + '-span').classList.remove('navbar-slider-static');
        }
    }
}


export function setNavbarTheme(color) {
    document.documentElement.style.setProperty('--main-navbar-theme', color);
}


export function setLogoWhite(value) {
    let images = document.getElementsByClassName('navbar-logo-image');
    for(let i = 0; i < images.length; i++) {
        value ? images[i].classList.add('navbar-logo-image-white') : images[i].classList.remove('navbar-logo-image-white');
    }
    let navbar = document.getElementsByClassName('navbar-dropdown');
    for(let i = 0; i < navbar.length; i++) {
        value ? navbar[i].classList.remove('navbar-white') : navbar[i].classList.add('navbar-white');
    }
}